<script setup lang="ts">
defineProps({
  fill: {
    type: String,
    default: () => 'currentColor',
  },
  direction: {
    type: String as () => 'up' | 'down' | 'left' | 'right',
    default: 'down',
    validator: (value: string) => ['up', 'down', 'left', 'right'].includes(value),
  },
  width: {
    type: String,
    default: '24',
  },
  height: {
    type: String,
    default: '24',
  },
});
const rotation = {
  up: -90,
  down: 90,
  left: 180,
  right: 0,
};
</script>

<template>
  <svg :width :height :fill viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" :style="`transform: rotate(${rotation[direction]}deg)`">
    <path d="M9.705 6L8.295 7.41L12.875 12L8.295 16.59L9.705 18L15.705 12L9.705 6Z" />
  </svg>
</template>

<style scoped>
svg {
  animation-duration: 0.2s;
  transition: transform 0.25s ease-out;
}
</style>
